export default __webpack_public_path__ + "static/media/About_Landing-12.ae71b77a.png";